import { Route, Routes } from "react-router-dom";
import { Routes as FleetWarehouseRoutes } from "./routes";
import { FleetWarehouseRouterCmp } from "./types";
import { WarehouseSearchPage } from "../pages/WarehouseSearchPage";
import { WarehouseDetailPage } from "../pages/WarehouseDetailPage";
import { WarehouseTireSetSearchPage } from "../pages/WarehouseTireSetSearchPage";


// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FleetWarehouseRouter: FleetWarehouseRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route path={WarehouseSearchPage.route} element={<WarehouseSearchPage />} />
        <Route path={WarehouseDetailPage.route} element={<WarehouseDetailPage />} />
        <Route path={WarehouseTireSetSearchPage.route} element={<WarehouseTireSetSearchPage />} />
      </Routes>
    </>
  );
};

FleetWarehouseRouter.route = FleetWarehouseRoutes.FleetWarehouseRouter;

export default FleetWarehouseRouter;
